import * as React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

export default class Content extends React.Component<{}, {}> {
  render() {
    return (
      <Grid className="content">
        <Row>
          <Col md={12} sm={12} xs={12} role="main" className="main">{this.props.children}</Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Content.tsx